/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.signature.defs'

export { $nsid }

type SigDetail = {
  $type?: 'tools.ozone.signature.defs#sigDetail'
  property: string
  value: string
}

export type { SigDetail }

const sigDetail = /*#__PURE__*/ l.typedObject<SigDetail>(
  $nsid,
  'sigDetail',
  /*#__PURE__*/ l.object({
    property: /*#__PURE__*/ l.string(),
    value: /*#__PURE__*/ l.string(),
  }),
)

export { sigDetail }
